import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import {
  updateBlockchain,
  updateFilterStatus,
  // selectBlockchain,
  // selectFilterStatus,
} from "../../rtk/features/filter/filterSlice";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 158,
    },
  },
};

export default function MultipleSelectCheckmarks(props) {
  const result = {};
  const dispatch = useDispatch();
  // const blockchainValue = useSelector(selectBlockchain);
  // const filterStatus = useSelector(selectFilterStatus);
  const blockchainValue = useSelector((state) => state.filter.blockchain);
  const filterStatus = useSelector((state) => state.filter.filterStatus);

  for (let i = 0; i < props.values.length; ++i) {
    const a = props.values[i];
    if (result[a] !== undefined) ++result[a];
    else result[a] = 1;
  }

  if (
    props.name === "Blockchain" &&
    blockchainValue.length === 1 &&
    filterStatus
  ) {
    dispatch(updateFilterStatus(false));
    props.filter(blockchainValue[0] === "All" ? [] : blockchainValue);
  }

  const [keyValue, setKeyValues] = React.useState(["All"]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (props.name === "Blockchain") {
      if ((value.length === 1 && value.indexOf("All") > -1) || !value.length) {
        dispatch(updateBlockchain(["All"]));
        props.filter([]);
      } else {
        let v =
          value.indexOf("All") === 0
            ? value.splice(value.indexOf("All") + 1, 1)
            : value;
        v = v.indexOf("All") > 0 ? ["All"] : v;

        dispatch(updateBlockchain(typeof v === "string" ? v.split(",") : v));
        props.filter(v[0] === "All" ? [] : v);
      }
    } else if (
      (value.length === 1 && value.indexOf("All") > -1) ||
      !value.length
    ) {
      setKeyValues(["All"]);
      props.filter([]);
    } else {
      let v =
        value.indexOf("All") === 0
          ? value.splice(value.indexOf("All") + 1, 1)
          : value;
      v = v.indexOf("All") > 0 ? ["All"] : v;
      setKeyValues(typeof v === "string" ? v.split(",") : v);
      props.filter(v[0] === "All" ? [] : v);
    }
  };

  return (
    <FormControl sx={{ m: 1, width: "90%" }}>
      <InputLabel id="demo-multiple-checkbox-label" size="small">
        {props.name}
      </InputLabel>
      {props.name === "Blockchain" ? (
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={blockchainValue}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
          size="small"
        >
          <MenuItem key={"All"} value={"All"}>
            <ListItemText primary={"All (" + props.values.length + ")"} />
          </MenuItem>
          {Object.entries(result).map((key) => (
            <MenuItem key={key[0]} value={key[0]}>
              <Checkbox checked={blockchainValue.indexOf(key[0]) > -1} />
              <ListItemText primary={key[0] + " (" + key[1] + ")"} />
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={keyValue}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
          size="small"
        >
          <MenuItem key={"All"} value={"All"}>
            <ListItemText primary={"All " + props.values.length} />
          </MenuItem>
          {Object.entries(result).map((key) => (
            <MenuItem key={key[0]} value={key[0]}>
              <Checkbox checked={keyValue.indexOf(key[0]) > -1} />
              <ListItemText primary={key[0] + " (" + key[1] + ")"} />
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
}
